<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span v-if="isEditMode">"{{ editedEntity.datasource.name | translate }}- {{ editedEntity.data.name | translate }}" {{ $t("common.update") }}</span>
        <span v-else>{{ $t("common.create") }}</span>
      </h2>

      <div>
        <right-panel class="float-right " id="sidebar-new-datasource" width="650px" :icon="'mdi mdi-plus'" :text="$t('datasource.new')" @hidden="rightPanelClosed">
          <div class="pl-5 pr-5 mt-4">
            <workspaceLibraryDatasourceForm v-if="isWorkspaceLayout" :hide-library="true" :closeOnSave="true" />
            <managementLibraryDatasourceForm v-else :hide-library="true" :closeOnSave="true" />
          </div>
        </right-panel>
      </div>
      <filter-select
        class="mt-4"
        id="datasourceFilter"
        ref="datasourceFilter"
        :placeholder="$t('datasource.select')"
        :isValid="!$v.form.datasource.$invalid"
        :multiple="true"
        @filter="onDatasourceSearch"
        :selected="form.datasource"
        @changed="datasourceSelect"
        track="_id"
      />
      <div class>
        <right-panel class="float-right " id="sidebar-new-data" width="650px" :icon="'mdi mdi-plus'" :text="$t('data.new')" @hidden="rightPanelClosed">
          <div class="pl-5 pr-5 mt-4">
            <workspaceLibraryDataForm v-if="isWorkspaceLayout" :hide-library="true" :closeOnSave="true" />
            <managementLibraryDataForm v-else :hide-library="true" :closeOnSave="true" />
          </div>
        </right-panel>
      </div>
      <filter-select
        class="mt-4"
        id="dataFilter"
        ref="dataFilter"
        :placeholder="$t('data.select')"
        :multiple="true"
        @filter="onDataSearch"
        :isValid="!$v.form.data.$invalid"
        :selected="form.data"
        @changed="dataSelect"
        track="_id"
      />

      <br />
      <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </form>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import ManagementLibraryDataForm from "../data/management-library-data-form";
import WorkspaceLibraryDataForm from "../data/workspace-library-data-form";
import ManagementLibraryDatasourceForm from "../datasource/management-library-datasource-form";
import WorkspaceLibraryDatasourceForm from "../datasource/workspace-library-datasource-form";

const state = "datasourceData";

export default {
  components: { WorkspaceLibraryDatasourceForm, WorkspaceLibraryDataForm, ManagementLibraryDataForm, ManagementLibraryDatasourceForm },
  props: ["state"],
  data() {
    return {
      form: { datasource: undefined, data: undefined },
    };
  },
  validations: {
    form: {
      datasource: {
        required,
      },
      data: {
        required,
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };
      },
    },
  },
  computed: {
    isWorkspaceLayout() {
      return this.state === "workspaceDatasourceData";
    },
    isUpdating() {
      return this.$store.getters[`${this.state}/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`${this.state}/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`${this.state}/isEditMode`];
    },
  },
  async mounted() {
    this.state = this.state || state;
  },

  methods: {
    rightPanelClosed() {
      this.$store.commit(`workspaceData/editedEntity`, null);
      this.$store.commit(`workspaceDatasource/editedEntity`, null);
      this.$refs?.datasourceFilter?.searchChanged("*");
      this.$refs?.dataFilter?.searchChanged("*");
    },
    async save() {
      const datasources = this.form.datasource;
      const childDatas = this.form.data;
      this.$emit("onSave", datasources, childDatas);
    },

    async onDatasourceSearch(value, callback) {
      const store = this.isWorkspaceLayout ? "workspaceDatasource" : "managementDatasource";
      const response = await this.$store.dispatch(`${store}/paginate`, {
        options: { limit: 200 },
        query: {
          name: { value },
          ...(!this.isWorkspaceLayout && { "scope.value": { value: "system", isObject: true } }),
        },
      });
      callback(response.data?.docs ?? []);
    },
    datasourceSelect(item) {
      this.form = { ...this.form, datasource: item };
    },
    async onDataSearch(value, callback) {
      const store = this.isWorkspaceLayout ? "workspaceData" : "managementData";
      const response = await this.$store.dispatch(`${store}/paginate`, {
        options: { limit: 200 },
        query: {
          name: { value },
          ...(!this.isWorkspaceLayout && { "scope.value": { value: "system", isObject: true } }),
        },
      });

      callback(response.data?.docs ?? []);
    },
    dataSelect(item) {
      this.form = { ...this.form, data: item };
    },
  },
};
</script>
